import { useAppSelector } from '../../Hooks/Hooks';
import { RootState } from '../../Redux/Store';
import './Footer.scss';

const Footer = () => {
  const { contentStackData } = useAppSelector((state: RootState) => state.ContentOrConfig);

  const schneiderLogo = contentStackData?.fpoo_footer?.[0]?.logo?.url;
  const privacyText = contentStackData?.fpoo_footer?.[0]?.footer_links?.[0]?.link?.title;
  const allRightsText = contentStackData?.fpoo_footer?.[0]?.copyright;
  const privacyUrl = contentStackData?.fpoo_footer?.[0]?.footer_links?.[0]?.link?.href;
  const links = contentStackData?.fpoo_footer?.[0]?.social_links;
  return (
    <div className="Footer px-5">
      <div className="Footer_Logo_Container">
        <img className="Footer_Logo" src={schneiderLogo} alt="logo" />
      </div>
      <div className="Footer_Rights_Container">{allRightsText}</div>
      <div className="Footer_Privacy_Container">
        <p>
          <a href={privacyUrl} target="_blank" rel="noreferrer">
            {privacyText}
          </a>
        </p>
      </div>
      <div className="Footer_Link_Container">
        {links?.map((item: any, index: number) => {
          return (
            <div className="mx-2" key={index}>
              <a href={item?.link.href} target="_blank" rel="noreferrer">
                <img src={item?.icon?.url} alt={item?.alt_text} />
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Footer;
